import { JSX, Ref } from 'preact'
import { forwardRef } from 'preact/compat'

const styles = {
  display: 'flex',
  flexDirection: 'column',
  width: '100px',
  boxShadow: '0 5px 11px 0 rgba(0, 0, 0, 0.1)',
  border: '1px solid rgb(231, 231, 244)',
  borderRadius: '10px',
  backgroundColor: '#ffffff',
  zIndex: 100,
  color: '#000000'
}

const itemStyle = {
  paddingTop: 6,
  paddingRight: 8,
  paddingBottom: 6,
  paddingLeft: 8,
  fontSize: 12
}

type Props = {
  urls: {
    ics: string
    google: string
    vcs: string
  }
  styles: {
    position: string
    top: number
    left: number
  }
}

const Calendar = forwardRef((props: Props, ref: Ref<HTMLDivElement>) => {
  const { urls } = props

  const onMouseEnter = (e: JSX.TargetedMouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.opacity = '0.6'
  }

  const onMouseLeave = (e: JSX.TargetedMouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.opacity = '1'
  }

  return (
    <div className="wf_reset" ref={ref} style={{ ...styles, ...props.styles }}>
      <a onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} style={itemStyle} href={urls.ics}>
        Apple
      </a>
      <a
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={itemStyle}
        rel="noreferrer"
        target="_blank"
        href={urls.google}
      >
        Google
      </a>
      <a onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} style={itemStyle} href={urls.vcs}>
        Outlook
      </a>
    </div>
  )
})

export default Calendar
